export const PROXYCLICK_VISITOR_STATUS = {
  CREATED: 'Created',
  CHECK_IN: 'check-in',
  CHECK_OUT: 'check-out',
  CANCELLED: 'Cancelled',
  CLOSED: 'Closed',
} as const;

